import { EditOutlined } from '@mui/icons-material';
import { ButtonBase } from '@mui/material';
import { forwardRef, type MouseEvent } from 'react';

/**
 * The pencil at the end of an editable property value: a 14 px teal edit
 * glyph that opens the value's editor.
 */
const PropertyEditButton = forwardRef<
    HTMLButtonElement,
    {
        'aria-label': string;
        onClick: (event: MouseEvent<HTMLButtonElement>) => void;
        'data-testid'?: string;
    }
>(function PropertyEditButton(props, ref) {
    return (
        <ButtonBase
            ref={ref}
            disableRipple
            {...props}
            sx={{
                flexShrink: 0,
                borderRadius: 0.5,
                color: 'primary.main',
                '&:hover, &:focus-visible': { bgcolor: 'action.hover' },
                '&:focus-visible': { outline: 1, outlineColor: 'primary.main' },
            }}
        >
            <EditOutlined sx={{ fontSize: 14 }} />
        </ButtonBase>
    );
});

export default PropertyEditButton;
